import React from 'react';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import { currencyDisplay } from '../../_utils';
function CartModalFooter(props) {
    const {
        tax,
        subtotal,
        hasItems,
        currencyFormat,
        currencyDisplayCode,
        locale,
    } = props;

    if (!hasItems) {
        return '';
    }

    return (
        <div className='cart-modal__footer'>
            <div className='cart-modal__footer-content'>
                {/*<div className="summary-list">
                    <div className="summary-list__item">
                        <div className="row row--xsmall">
                            <div className="col-xs-7">
                                <span className="summary-list__heading"><LocalizedMessage id={'TAX'} /></span>
                            </div>
                            <div className="col-xs-5">
                                <span className="summary-list__value">{Numeral(tax).format('$ 0,0.00')}</span>
                            </div>
                        </div>
                    </div>
                </div>*/}
                <div className='summary-total'>
                    <div className='row row--xsmall'>
                        <div className='col-xs-7'>
                            <span className='summary-total__heading'>
                                <LocalizedMessage id={'SUBTOTAL'} />
                            </span>
                        </div>
                        <div className='col-xs-5'>
                            <span className='summary-total__value'>
                                {currencyDisplay(
                                    subtotal,
                                    currencyDisplayCode,
                                    currencyFormat,
                                    locale
                                )}
                            </span>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-xs-12'>
                        <a
                            href={`${window.pathURL}checkout`}
                            type='submit'
                            className='cart-modal__button button button--uppercase button--block'
                            title={getTranslation('CHECKOUT')}
                        >
                            <span>
                                <LocalizedMessage id={'CHECKOUT'} />
                            </span>
                        </a>
                    </div>
                    <div className='col-xs-12'>
                        <button
                            type='button'
                            className='button button--block button--transparent button--small'
                            data-toggle-cart
                            title={getTranslation('CONTINUE_SHOPPING')}
                        >
                            <LocalizedMessage id={'CONTINUE_SHOPPING'} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CartModalFooter;
